import React from "react";
import { NavLink } from "react-router-dom";
import "./ProfileAvatarDropdown.css";

const ProfileAvatarDropdown = () => {
  return (
    <div className="profileAvatarDropdownMenu">
      <ul>
         {/* Home Link */}
                <li>
                  <NavLink to="/new-home" className="nav-link">
                    Home
                  </NavLink>
                </li>
        
                {/* Blog Posts Link */}
                <li>
                  <NavLink to="/games" className="nav-link">
                  Games
                  </NavLink>
                </li>
        
                {/* Blog News Link */}
                <li>
                  <NavLink to="/new-blog-home/article/1" className="nav-link">
                  Blog
                  </NavLink>
                </li>
        
                {/* Blog Videos Link */}
              
        
        {/* Blog Videos Link */}
        <li>
                  <NavLink to="/animehub" className="nav-link">
                  Anime
                  </NavLink>
                </li>
        {/* Blog Videos Link */}
        <li>
                  <NavLink to="/profile" className="nav-link">
                  Profile
                  </NavLink>
                </li>

        {/* Security and Privacy */}

      </ul>
    </div>
  );
};

export default ProfileAvatarDropdown;
